__turbopack_context__.v({
  "LoadSpinner": "KYZWWq_LoadSpinner",
  "LoadSpinnerWrapper": "KYZWWq_LoadSpinnerWrapper",
  "spin": "KYZWWq_spin",
});
